import {URLS} from "../../constants/appConstants";

export function QuestionExamples(props) {
  return <>
    <h2>This page is not part of app.</h2>
    <a href={URLS.QUESTION_EXAMPLE_CROSSWORD}>
      Crossword
    </a>
    <br/>
    <a href={URLS.QUESTION_EXAMPLE_JIGSAW_PUZZLE}>
      Jigsaw
    </a>
    <br/>
    <a href={URLS.QUESTION_EXAMPLE_FLASH_CARD}>
      Flash card example
    </a>
    <br/>
    <a href={URLS.QUESTION_EXAMPLE_DOUBLE_PUZZLE}>
      Double Puzzle
    </a>
    <br/>
  </>;
}